import TiptapParagraph from '@tiptap/extension-paragraph';

export const Paragraph = TiptapParagraph.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      HTMLAttributes: {
        ...(this.parent?.().HTMLAttributes ?? {}),
        class: 'editor-paragraph',
      },
    };
  },

  renderHTML({ HTMLAttributes }) {
    // Merge base 'editor-paragraph' class with any node-specific classes
    const parentClass = this.options.HTMLAttributes?.class ?? '';
    const extraClass = HTMLAttributes?.class ?? '';
    const mergedClass = [parentClass, extraClass].filter(Boolean).join(' ');

    return [
      'p',
      { ...this.options.HTMLAttributes, ...HTMLAttributes, class: mergedClass },
      0,
    ];
  },
});
